



































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import APIService from '@/api';
import SignUpService from '@/api/SingupService';

import { Surface } from '@/components/atoms';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import InfoIcon from '@/components/icons/InfoV2.vue';
import InviteMailBox from '@/componentsV2/molecules/InviteMailBox/InviteMailBox.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import eventBus from '@/utils/eventBus';

type InviteData = {
  invitedMail: string;
  inviteCode: string;
  isDifferentAccount: boolean;
};

@Component({
  components: {
    CloseModalIcon,
    Surface,
    FilledButton,
    InfoIcon,
    InviteMailBox,
    Typography
  }
})
export default class InvitationDifferentAccountModal extends Vue {
  @Prop({ default: () => ({}) }) inviteData!: InviteData;

  signUpService = new SignUpService();

  @Watch('$route')
  onRouteChange() {
    this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  logOut() {
    APIService.resetCredentials(() => {
      window.location.assign(`/invite/${this.inviteData.inviteCode}`);
    });
  }
}
